import { render, staticRenderFns } from "./lesson_home.vue?vue&type=template&id=07a4d5fe&scoped=true"
import script from "./lesson_home.vue?vue&type=script&lang=js"
export * from "./lesson_home.vue?vue&type=script&lang=js"
import style0 from "./lesson_home.vue?vue&type=style&index=0&id=07a4d5fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a4d5fe",
  null
  
)

export default component.exports